import React, { Fragment, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import PropTypes from 'prop-types'

import Branding from './branding'
import ThemeToggle from './theme-toggle'
import './header.css'

const Header = (props) => {
  const location = useLocation()
  const [mobileOpen, setMobileOpen] = useState(false)

  const isActive = (path) => location.pathname === path

  return (
    <header className={`header-header ${props.rootClassName} `}>
      <header data-thq="thq-navbar" className="header-navbar-interactive">
        <div className="header-branding">
          <Link to="/about" className="header-navlink">
            {props.text ?? (
              <Fragment>
                <span className="header-text21">Abhishek Palit   </span>
              </Fragment>
            )}
          </Link>
          <span className="header-text10">
            {props.text1 ?? (
              <Fragment>
                <span className="header-text23">
                  Architecture Technology &amp; Sustainability
                </span>
              </Fragment>
            )}
          </span>
        </div>
        <div
          data-thq="thq-navbar-nav"
          data-role="Nav"
          className="header-desktop-menu"
        >
          <nav className="header-links1">
            <Link to="/" id="home" name="home" className={`header-home1 button ${isActive('/') ? 'nav-active' : ''}`}>
              <span className="header-home2">
                {props.text2 ?? (
                  <Fragment>
                    <span className="header-text17">home</span>
                  </Fragment>
                )}
              </span>
            </Link>
            <Link
              to="/projects"
              id="projects"
              className={`header-projects1 button ${isActive('/projects') ? 'nav-active' : ''}`}
            >
              <span className="header-projects2">
                {props.text21 ?? (
                  <Fragment>
                    <span className="header-text22">projects</span>
                  </Fragment>
                )}
              </span>
            </Link>
            <Link
              to="/articles"
              id="articles"
              className={`header-articles1 button ${isActive('/articles') ? 'nav-active' : ''}`}
            >
              <span className="header-articles2">
                {props.text3 ?? (
                  <Fragment>
                    <span className="header-text24">articles</span>
                  </Fragment>
                )}
              </span>
            </Link>
            <Link to="/about" id="about" className={`header-about1 button ${isActive('/about') ? 'nav-active' : ''}`}>
              <span className="header-about2">
                {props.button ?? (
                  <Fragment>
                    <span className="header-text18">about me</span>
                  </Fragment>
                )}
              </span>
            </Link>
          </nav>
          {props.themeToggle}
        </div>
        <div className="header-right-group">
          {props.themeToggle && (
            <div className="header-theme-mobile">{props.themeToggle}</div>
          )}
          <div
            data-thq="thq-burger-menu"
            className="header-burger-menu"
            onClick={() => setMobileOpen(true)}
          >
            <img
              alt={props.hamburgerAlt}
              src={props.hamburgerSrc}
              className="header-hamburger"
            />
          </div>
        </div>
        <div
          data-thq="thq-mobile-menu"
          className={`header-mobile-menu ${mobileOpen ? 'teleport-show' : ''}`}
        >
          <div className="header-top">
            <Branding
              text21={
                <Fragment>
                  <span className="header-text11">Abhishek Palit  </span>
                </Fragment>
              }
              text31={
                <Fragment>
                  <span className="header-text12">
                    Architecture, Technology &amp; Sustainability
                  </span>
                </Fragment>
              }
              rootClassName="brandingroot-class-name"
            ></Branding>
            <div
              data-thq="thq-close-menu"
              className="header-menu-close"
              onClick={() => setMobileOpen(false)}
            >
              <svg viewBox="0 0 1024 1024" className="header-icon10">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <nav className="header-links2">
            <Link to="/" className="header-button1 button" onClick={() => setMobileOpen(false)}>
              <span className="header-home2">home</span>
            </Link>
            <Link to="/projects" className="header-button1 button" onClick={() => setMobileOpen(false)}>
              <span>
                {props.text4 ?? (
                  <Fragment>
                    <span className="header-text20">projects</span>
                  </Fragment>
                )}
              </span>
            </Link>
            <Link to="/articles" className="header-button2 button" onClick={() => setMobileOpen(false)}>
              <span>
                {props.text5 ?? (
                  <Fragment>
                    <span className="header-text16">articles</span>
                  </Fragment>
                )}
              </span>
            </Link>
            <Link to="/about" className="header-button3 button" onClick={() => setMobileOpen(false)}>
              <span>
                {props.button1 ?? (
                  <Fragment>
                    <span className="header-text19">about me</span>
                  </Fragment>
                )}
              </span>
            </Link>
          </nav>
          <div className="header-social-bar">
            <a href="https://www.linkedin.com/in/abhishek-palit/" target="_blank" rel="noreferrer noopener">
              <svg viewBox="0 0 1024 1024" className="header-social-icon">
                <path d="M384 384h177.106v90.782h2.532c24.64-44.194 84.958-90.782 174.842-90.782 186.946 0 221.52 116.376 221.52 267.734v308.266h-184.61v-273.278c0-65.184-1.334-149.026-96.028-149.026-96.148 0-110.82 70.986-110.82 144.292v278.012h-184.542v-576zM64 384h192v576h-192v-576zM256 224c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z"></path>
              </svg>
            </a>
            <a href="https://github.com/abhipalit3" target="_blank" rel="noreferrer noopener">
              <svg viewBox="0 0 1024 1024" className="header-social-icon">
                <path d="M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM775.27 775.27c-37.23 37.23-80.6 66.46-128.93 86.84-50.06 21.12-103.26 31.84-158.11 31.84-54.85 0-108.05-10.72-158.11-31.84-48.33-20.39-91.7-49.61-128.93-86.84s-66.46-80.6-86.84-128.93c-21.12-50.06-31.84-103.26-31.84-158.11 0-82.45 24.21-161.16 69.97-229.01 45.19-66.98 108.72-118.86 183.67-150.07-2.52 22.63-2.52 57.89-2.52 57.89l0.36 99.26c0 0-20.04-0.36-42.31-0.36-62.03 0-76.4 28.13-87.14 55.33-6.45 16.57-14.22 28.84-27.07 39.89-5.89 5.07-7.53 10.05-1.13 11.63 29.36 7.27 50.57-17.53 69.34-42.23 13.63-17.93 28.71-29.2 52.49-29.2 18.39 0 45.37 0.72 62.94 5.79-12.73 39.6-0.84 68.96-0.84 68.96s-84.84 12.15-84.84 130.97c0 39.04 13.32 62.14 32.64 82.29-6.12 22.3-14.41 66.36 4.25 88.43 43.66 0 70.13-28.78 82.22-44.43 23.63 8.62 50.64 13.56 80.39 13.56 30.05 0 57.35-5.1 81.22-13.93 11.97 15.54 38.6 44.8 82.47 44.8 18.84-22.27 10.39-66.69 4.19-89.07 18.85-19.99 31.73-42.78 31.73-81.65 0-118.58-84.36-131.18-84.36-131.18s11.46-28.56-0.79-67.97c22.61-6.53 61.66-7.37 91.71 27.02 21.69 24.85 14.44 48.63 69.11 48.63 6.72 0 9.88-5.74 3.64-11.31-12.32-10.98-19.72-22.33-26.01-38.18-10.37-26.15-23.98-56.63-87.32-56.63-16.61 0-35.56-0.36-35.56-0.36l0.18-87.38s0-34.6-2.45-56.27c74.78 31.28 138.17 83.12 183.3 149.96 45.77 67.85 69.97 146.55 69.97 229.01 0 54.85-10.72 108.05-31.84 158.11-20.38 48.33-49.61 91.7-86.84 128.93z"></path>
              </svg>
            </a>
          </div>
        </div>
      </header>
    </header>
  )
}

Header.defaultProps = {
  text5: undefined,
  text2: undefined,
  button: undefined,
  hamburgerAlt: 'image',
  button1: undefined,
  text4: undefined,
  text: undefined,
  text21: undefined,
  rootClassName: '',
  text1: undefined,
  hamburgerSrc: '/group%202084%5B1%5D.svg',
  text3: undefined,
  themeToggle: null,
}

Header.propTypes = {
  text5: PropTypes.element,
  text2: PropTypes.element,
  button: PropTypes.element,
  hamburgerAlt: PropTypes.string,
  button1: PropTypes.element,
  text4: PropTypes.element,
  text: PropTypes.element,
  text21: PropTypes.element,
  rootClassName: PropTypes.string,
  text1: PropTypes.element,
  hamburgerSrc: PropTypes.string,
  text3: PropTypes.element,
  themeToggle: PropTypes.element,
}

export default Header
